import { Label } from '@/shared/ui/label';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/shared/ui/input-otp';

interface OtpInputProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    maxLength?: number;
}

export function OtpInput({
    value,
    onChange,
    label = 'Verification code',
    maxLength = 6,
}: OtpInputProps) {
    return (
        <div className="space-y-2">
            <Label>{label}</Label>
            <div className="flex justify-center">
                <InputOTP maxLength={maxLength} value={value} onChange={onChange}>
                    <InputOTPGroup>
                        {Array.from({ length: maxLength }).map((_, index) => (
                            <InputOTPSlot key={index} index={index} />
                        ))}
                    </InputOTPGroup>
                </InputOTP>
            </div>
        </div>
    );
}
